import { useNoticeDetailModel } from '@src/views/authPortal/notice/detail/detailModel';
import { noticeService } from '@src/views/authPortal/notice/NoticeService';
import { IMdNoticeFields, IFileFields } from '@src/views/authPortal/notice/NoticeTypes';
import { Tabs, message, Tooltip } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import FontIcon from '../YhIcon';
import PreviewModal from "../YnPreview/index";
import "./index.less";

const { TabPane } = Tabs;
type YhNoticePropsType = {
	content: IMdNoticeFields,
	disabled?: boolean,
	height?: string,
}

type IPreviewInfoType = {
	visible: boolean,
	md5: string,
	fileName: string,
	filePath: string
}

const YhNotice = (props: YhNoticePropsType) => {
	const {
		content,
		disabled = false,
		height
	} = props

	const { downloadFile } = useNoticeDetailModel();
	const [reader, setReader] = useState<string[]>([]);
	const [unRead, setUnRead] = useState<string[]>([]);

	//预览附件内容
	const [previewInfo, setPreviewInfo] = useState<IPreviewInfoType>({
		visible: false,
		md5: "",
		fileName: "",
		filePath: ""
	});
	//关闭附件弹框
	const onCancel = () => {
		setPreviewInfo({ visible: false, md5: "", fileName: "", filePath: "" })
	}
	//打开附件弹框
	const onPreview = (item: IFileFields) => {
		var fileName = item.attachName?.substring(item.attachName.lastIndexOf(".") + 1).toLowerCase();
		let arr = ["pdf", "docx", "png", "jpg", "gif"];
		// if (!arr.includes(fileName)) {
		// 	message.warning("目前只支持['pdf', 'docx','png', 'jpg', 'gif']这五种格式文件的预览,您可以通过下载本地进行查看");
		// 	return;
		// }
		let filePath: string[] = item.filePath?.split("/") ?? [];
		setPreviewInfo({
			visible: true,
			md5: item.id ?? item?.uid,
			fileName: item.attachName,
			filePath: filePath.length > 0 ? filePath[filePath.length - 1] : ""
		});
	}

	const initNoticeReader = async () => {
		try {
			const { retData: readUser } = await noticeService.noticeReader(content.id as string)
			const { retData: unread } = await noticeService.noticeUnReader(content.id as string)
			// console.log('reader:', reader);
			// console.log('unReader:', unReader);
			setReader(readUser)
			setUnRead(unread)
		} catch (error) {

		}
	}
	useEffect(() => {
		setTimeout(() => {
			initNoticeReader()
		}, 200)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [content])
	// const operations = <Button>Extra Action</Button>;
	return (
		<>
			<div className="notice-item-inner" style={{ maxHeight: height }}>
				<div className="title">{content?.title}</div>
				<div className="from">
					<span>{content?.authorName}</span>
					<span className="line"> | </span>
					<span>{content?.sourceOrgName}</span>
				</div>
				<div className="time">{moment(content?.pubTime).format('YYYY-MM-DD HH:mm:ss')}</div>
				<div className="content" dangerouslySetInnerHTML={{
					__html: content?.contentHtml as string
				}} />
				<div className="flex justify-between footer">
					<span>附件：</span>
					<div className="reader" hidden={!content?.read && !content?.unRead}>
						<span className="is-reader">{content?.read ?? 0} 人已读</span>
						<span>{content?.unRead ?? 0} 人未读</span>
					</div>
				</div>
				<div className="notice-file-warp">
					{
						content?.attachInfo?.map(item =>
							<div className="flex file mt-18" key={item.id ?? item.uid}>
								{
									item.fileType.indexOf('image/') !== -1 ? <FontIcon style={{ fontSize: '43px' }} type="icon-tupian2" />
										: item.attachName.indexOf('.pdf') !== -1 ? <FontIcon style={{ fontSize: '43px' }} type="icon-pdf" />
											: <FontIcon style={{ fontSize: '43px' }} type="icon-order" />
								}
								<div className="flex-1 pl-10 w100 pr-20 lh-1">
									<Tooltip title={item.attachName}>
										<div className="link one-line" onClick={() => disabled ? undefined : onPreview(item)}>{item.attachName}</div>
									</Tooltip>
									<div className="text-left mt-10 pr-20" style={{ color: "#B1B0B0" }}>
										<span style={{ display: "inline-block", width: "100px" }}>{(item.fileSize / 1024).toFixed(1)} kb </span>
										<span className="notice-file-warp-d" onClick={() => disabled ? undefined : downloadFile(item.id)}>下载</span>
									</div>
									{/* <div className="text-right pt-5"><span className="preview-attachment-btn" onClick={() => onPreview(item)}>预览附件</span></div> */}
								</div>
							</div>
						)
					}
				</div>
				{/* <Tabs tabBarExtraContent={operations}> */}
				<Tabs>
					<TabPane tab={`已读 ${reader.length}`} key="1">
						{
							reader.map((item, index) => <span className="user-item" key={index}>{item}</span>)
						}
					</TabPane>
					<TabPane tab={`未读 ${unRead.length}`} key="2">
						{
							unRead.map((item, index) => <span className="user-item" key={index}>{item}</span>)
						}
					</TabPane>
				</Tabs>
			</div>
			{previewInfo.visible && <PreviewModal
				visible={previewInfo.visible}
				onCancel={onCancel}
				md5Id={previewInfo.md5}
				fileName={previewInfo.fileName}
				filePath={previewInfo.filePath}
			/>}
		</>
	)
}
export default YhNotice;